<div>
    <ng-container *ngIf="options">
        <aumico-form [options]="options" [delegate]="formDelegate"></aumico-form>
    </ng-container>
</div>
